import React, { useEffect, useState } from 'react'
import Flex from 'ui/Flex'
import Loader from 'ui/Loader'
import { CategoryWrapper } from 'features/ProvidersContent/styled'
import GameList from 'features/GamesList/GameList'
import Box from 'ui/Box'
import MediaGrid from 'ui/MediaGrid'
import moment from 'moment'
import GamesService from '../../services/GamesService'
import { useHistory, useRouteMatch } from 'react-router-dom'
import GamesSlider from '../GamesSlider'
import CategoryTitle from '../GamesSlider/CategoryTitle'
import { byMedia } from '../../common/adapters/DeviceDetectAdapter'
import { LIVE_CASINO_PROVIDERS, PROVIDERS } from '../../common/providers'
import InfinityScroller from '../Scroll/InfinityScroller'
import { renderLoader } from 'ui/RenderLoader'
import Text from 'ui/Text'
import gamesService from '../../services/GamesService'

const onPageTop = byMedia({
    sm: 1.5,
    md: 2,
    lg: 2,
    xl: 3,
})

const onPageNew = byMedia({
    sm: 1.5,
    md: 3,
    lg: 3,
    xl: 4,
})

const gamesToShow = 12

const ProviderItem = () => {
    const match = useRouteMatch()
    const history = useHistory()

    const [allGames, setAllGames] = useState([])
    const [gamesToMap, setGamesToMap] = useState([])
    const [preparedGames, setPreparedGames] = useState(allGames)
    const [newGames, setNewGames] = useState([])
    const [topGames, setTopGames] = useState([])
    const [provider, setProvider] = useState({})
    const [pageNumber, setPageNumber] = useState(1)
    const [lastPage, setLastPage] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const findProvider = PROVIDERS.find(
        (item) => item.value === match.params.subCategory
    )

    const filterNewGames = (games) =>
        [...games] // Create a copy of the array using spread operator due to it brakes sorting
            .sort(
                (a, b) =>
                    (parseInt(
                        moment(b.release_date).format('YYYYMMDDHHmmss')
                    ) || 0) -
                        (parseInt(
                            moment(a.release_date).format('YYYYMMDDHHmmss')
                        ) || 0) ||
                    b.rod_new - a.rod_new ||
                    parseInt(a.priority) - parseInt(b.priority) ||
                    a.name.localeCompare(b.name)
            )
            .slice(0, 4)

    const fetchGames = (subproviderName, pageNumber) => {
        const filterName =
            subproviderName === 'scientific'
                ? 'scientific,gdm'
                : subproviderName
        setIsLoading(true)
        GamesService.searchGames(
            `filter[subprovider]`,
            filterName,
            gamesToShow,
            pageNumber,
            true
        )
            .then((res) => {
                if (res?.games?.length) {
                    setAllGames((prev) => [...prev, ...res.games])
                    setLastPage(res.meta.last_page)
                    setIsLoading(false)
                } else {
                    history.push('/404')
                }
            })
            .catch(console.error)
    }

    const loadMore = () => {
        if (pageNumber < lastPage) {
            setIsLoading(true)
            setPageNumber((prev) => prev + 1)
        }
    }

    const isLiveCasinoProvider = (provider) =>
        LIVE_CASINO_PROVIDERS.indexOf(provider) > -1

    /* TODO TEMP solution while we don't have an endpoint to get new games list*/
    const filterByProvider = (games, subprovider) =>
        games.filter((game) => {
            const subproviderName =
                subprovider === 'scientific' ? 'scientific,gdm' : subprovider
            return game.subprovider === subproviderName
        })

    useEffect(() => {
        const allGamesSub = gamesService
            .getAllProvidersGames()
            .subscribe((allGames) => {
                setGamesToMap(allGames)
            })

        setProvider(findProvider)

        return () => {
            allGamesSub.unsubscribe()
        }
    }, [])

    useEffect(
        () => {
            if (gamesToMap.length) {
                const providerGames = filterByProvider(
                    gamesToMap,
                    match.params.subCategory
                )
                const newGamesSorting = new Array(...providerGames)
                setNewGames(filterNewGames(newGamesSorting))
            }
        },
        [gamesToMap]
    )

    /* END */

    useEffect(
        () => {
            fetchGames(match.params.subCategory, pageNumber)
        },
        [pageNumber]
    )

    useEffect(
        () => {
            if (allGames.length) {
                const gameWithLiveCasino = isLiveCasinoProvider(provider.value)
                    ? GamesService.liveCasinoDataHandler([...allGames])
                    : [...allGames]

                setPreparedGames(gameWithLiveCasino)
                setTopGames(gameWithLiveCasino.slice(0, 3))
                setIsLoading(false)
            }
        },
        [allGames]
    )

    return !Object.keys(provider).length && !allGames.length ? (
        <Flex mt={3}>
            <Loader />
        </Flex>
    ) : (
        <>
            {!!topGames.length && (
                <CategoryWrapper>
                    <GamesSlider
                        gamesData={topGames}
                        showNumberLabel={true}
                        title={'Top 3 fra ' + provider.label}
                        onPage={onPageTop}
                    />
                </CategoryWrapper>
            )}
            {!!newGames.length && (
                <CategoryWrapper>
                    <GamesSlider
                        gamesData={newGames}
                        vertical
                        title={'Nyheder'}
                        onPage={onPageNew}
                    />
                </CategoryWrapper>
            )}
            <CategoryWrapper>
                <CategoryTitle title={'Alle spil'} />
                <Box my={3}>
                    <MediaGrid>
                        <InfinityScroller
                            maxItems={preparedGames.length}
                            onScrollToBottom={loadMore}
                            isLoading={isLoading}
                        >
                            <GameList
                                games={preparedGames}
                                limit={preparedGames.length}
                            />
                        </InfinityScroller>
                    </MediaGrid>
                </Box>
                {isLoading
                    ? renderLoader()
                    : preparedGames.length === 0 &&
                      !isLoading && (
                          <Text align={'center'} pt={3}>
                              Ingen match fundet.
                          </Text>
                      )}
            </CategoryWrapper>
        </>
    )
}

export default ProviderItem
